(() => {
  const getDisplayItemCount = (cart) => {
    const countedBoxes = new Set();

    return (cart?.items || []).reduce((count, item) => {
      const boxId = item.properties?._velvet_box_id;
      if (!boxId) return count + (Number(item.quantity) || 0);
      if (countedBoxes.has(boxId)) return count;
      countedBoxes.add(boxId);
      return count + 1;
    }, 0);
  };

  const updateCartCount = (count) => {
    document.querySelectorAll("[data-velvet-cart-count]").forEach((element) => {
      const singular = element.dataset.singular || "item";
      const plural = element.dataset.plural || "items";
      element.textContent = `${count} ${count === 1 ? singular : plural}`;
    });
  };

  document.addEventListener("cart:updated", (event) => {
    const cart = event.detail?.cart;
    if (cart?.items) updateCartCount(getDisplayItemCount(cart));
  });
})();
